import * as React from 'react';
import classNames from 'classnames';
import { IActivityModel } from 'src/Entities/Activity/Activity';
import { format, compareAsc } from 'date-fns';
import Tag from 'src/components/Tag';
import { Columns, Column } from 'src/components/Layout/Grid';
import Box from 'src/components/Box';
import logo from 'src/images/Logos/3f-logo.svg';
import LinkButton from 'src/components/Button/LinkButton';
import Icon from 'src/components/Icon';
import { IComingCourses } from 'src/Entities/User/User';
import Button from 'src/components/Button';
import { mitFiuUrl } from 'src/helpers/WebHelper';
import MyPageShowInterestsComponent from '../MyPage/myPageShowInterests.component';

interface IProps {
  comingActivities: IComingCourses[];
  showSmallComponent: boolean;
  setSelectedActivity: (detailKursusId: number) => void;
}

class MyPageComingCourses extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    this.renderActivity = this.renderActivity.bind(this);
  }

  public getActivities(): IComingCourses[] {
    const { comingActivities } = this.props;

    return comingActivities.sort((a, b) =>
      compareAsc(new Date(a.activity.startDate), new Date(b.activity.startDate))
    );
  }

  public EnrollMentTag(activity: IComingCourses) {
    if (activity.enrollmentStatus === undefined) {
      return null;
    }
    const status = activity.enrollmentStatus.toString();
    let tag;
    switch (activity.enrollmentStatus) {
      case 'Tilmeldt':
        tag = <Tag color="success"> {status} </Tag>;
        break;
      case 'Aflyst':
        tag = <Tag color="cancelled">{status}</Tag>;
        break;
      default:
        tag = <Tag color="warning"> {status} </Tag>;
        break;
    }
    return tag;
  }

  public renderActivity(activity: IComingCourses, index: number) {
    const isLast = this.props.comingActivities.length - 1 === index;

    return (
      <Columns
        key={activity.detailKursusId}
        className={classNames('f5 mt3', {
          mb2: isLast
        })}
      >
        <Column md={3} className="mr2-md">
          <div className="image is-square has-background-gray-body">
            <img src={logo} />
          </div>
        </Column>
        <Column md="fill" className="flex flex-column">
          <div className="has-color-dark-2 font-bold">
            {format(new Date(activity.activity.startDate), 'dd.MM.yyyy')} -{' '}
            {activity.activity.startTime}
          </div>
          <div
            onClick={() =>
              this.props.setSelectedActivity(activity.detailKursusId)
            }
            style={{ cursor: 'pointer' }}
            className="font-bold flex-auto"
          >
            {activity.activity.courseTitle}
          </div>
          <div>{this.EnrollMentTag(activity)}</div>
        </Column>
      </Columns>
    );
  }

  public render() {
    const activities = this.getActivities();
    const count = activities.length;
    const txt =
      count !== 0
        ? `Mine kommende kurser: (${count})`
        : 'Du har ingen kommende kurser';

    return (
      <Box>
        {!this.props.showSmallComponent ? (
          <div>
            <div className="fw8 f5 ttu mb2">{txt}</div>
            <div>
              {activities && activities.map(this.renderActivity)}
              <div>
                <a
                  href={mitFiuUrl}
                  target="_blank"
                  style={{ textDecoration: 'none' }}
                >
                  <Button className="mt2" color="gray">
                    Se hele din historik her - på mitfiu.dk
                    <Icon name={'chevron-right'} />
                  </Button>
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="border-b-4 border-gray-body pb-4 mb-4">
              <MyPageShowInterestsComponent label="Vis kun relevante kurser" />
            </div>
            <div className="fw8 f5 ttu mb2">{txt}</div>
            <div>
              {activities && activities.slice(0, 2).map(this.renderActivity)}
              <LinkButton className="mt2" color={'gray'} to={'/min-side'}>
                Mine interesser og kursusområder
                <Icon name={'chevron-right'} />
              </LinkButton>
            </div>
          </div>
        )}
      </Box>
    );
  }
}

export default MyPageComingCourses;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/MyPage/myPageComingCourses.component.tsx